import { withTitle } from '@hoc/withTitle';
import { EpisodeDetailsDrawer } from '@insights_module/components/episode_details_screen/EpisodeDetailsDrawer';
import { Layout } from '@insights_module/components/Layout';
import { LibraryTable } from '@insights_module/components/LibraryTable';
import { ShowDetailsDrawer } from '@insights_module/components/show_details_screen/ShowDetailsDrawer';
import { EpisodeDetailsProvider } from '@insights_module/context/EpisodeDetailsContext';

const _MyLibraryPage = () => {
  return (
    <Layout.InsightsPage>
      <LibraryTable />

      <ShowDetailsDrawer />

      <EpisodeDetailsProvider>
        <Layout.EpisodesDetailsWrapper>
          <EpisodeDetailsDrawer />
        </Layout.EpisodesDetailsWrapper>
      </EpisodeDetailsProvider>
    </Layout.InsightsPage>
  );
};

export const MyLibraryPage = withTitle(_MyLibraryPage, 'insights.my_library_page.title');
